import React, { useState } from 'react';
import { Box, Button, Flex, Grid, GridItem, Image, ListItem, OrderedList, Radio, RadioGroup, Text } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import interLogo from "../Assets/Images/interswitch_group_logo.svg.svg";
import paystackLogo from "../Assets/Images/paystackLogo.svg";
import remitalogo from "../Assets/Images/remita-logo.svg";
import visaLogo from "../Assets/Images/visa_inc_logo.svg.svg";
import { setFormModal } from '../redux/slices/modalSlice';
import { setloadTost } from '../redux/slices/toastSlice';
import {makePayment} from "../components/RemitaPayment";
import {setPaymentConfirmation} from  "../redux/slices/studentApplicationApprovalSlice";
import { confirmRemitaPayment } from '../services/paymentMethodService';

const MemberProfilePaymentModal = () => {
    const dispatch = useDispatch();
    const paymentDetailsData = useSelector((state) => state?.myDues?.myDuesDetails);
    const paymentTypeData = [
        { title: "Remita", logo: remitalogo },
        { title: "Interswitch", logo: interLogo },
        { title: "Paystack", logo: paystackLogo },
        { title: "Visa", logo: visaLogo },
    ]

    const [selectedPaymentOption, setSelectedPaymentOption] = useState(null);
    const handlePaymentOptionChange = (value) => {
        setSelectedPaymentOption(value);
    };

    const successFunc = async(referenceId) => {
        try {
            const response = await confirmRemitaPayment(referenceId);
           
            if(!response?.isSuccess === true) {
                dispatch(setloadTost({ title: 'Error', description: `${response?.response?.data?.error?.description || response?.errors?.map((errors) => errors) || "Failed to confirm payment"} `, status: 'warning', duration: 5000, isClosable: true, position: 'top' }));
            }else{
                dispatch(setloadTost({ title: 'Confirmation', description: `Verified Successfully `, status: 'success', duration: 5000, isClosable: true, position: 'top' }));
                dispatch(setPaymentConfirmation(true));
            }
        } catch (error) {
            console.error(error);
        }
    }

    const handleSubmitPayment = () => {
        if (selectedPaymentOption !== null) {
            if(selectedPaymentOption === "Remita") {
                makePayment({orderId: paymentDetailsData?.orderId, referenceId: paymentDetailsData?.referenceId, successFunc: successFunc});
                dispatch(setFormModal({ status: false, data: null }));
            }
        }else {
            dispatch(setloadTost({ title: 'Empty Field', description: `Please select a payment option `, status: 'warning', duration: 5000, isClosable: true, position: 'top' }));
        }
    }

    return (
        <Box py={'20px'} minH={'100vh'} maxWidth={'auto'}>
            <Box mt={5}>
                <Box px={['20px', '40px', '40px']} py={'30px'}> 
                    <Flex flexDirection={['column', 'column', 'column', 'row']} gap={'30px'}>
                        <Flex flexDirection={'column'} width={['100%', '100%', '100%', '65%']} gap={4} >
                            <Flex alignItems={'center'} gap={3} bgColor={'#D7343926'} px={['20px', '40px', '40px']} py={'20px'}>
                                <Text color={'#D11A2A'} fontFamily={'inter'} fontWeight={'600'} fontSize={'14px'} lineHeight={'100%'} >SELECT A PAYMENT PLATFORM BELOW</Text>
                            </Flex>
                            <RadioGroup value={selectedPaymentOption} onChange={handlePaymentOptionChange}>
                                <Grid templateColumns={['repeat(1, 1fr)', 'repeat(1, 1fr)', 'repeat(2, 1fr)', 'repeat(2, 1fr)']} gap={5}>
                                    {paymentTypeData && paymentTypeData?.map((item, index) => (
                                        <GridItem key={index} w={'full'}>
                                            <Flex bgColor={'#FFFFFF'} justifyContent={'center'} flexDirection={'column'} alignItems={'center'} gap={5} p={5} w={'full'} border={'1px solid #C4C4C4'} borderRadius={'5px'} mb={4}>
                                                <Image src={item?.logo} alt='payment logo' width={['150px', '200px', '300px', '100px']} h={'40px'} />
                                                <Flex justifyContent={'center'} alignItems={'center'} gap={5} width={'full'}>
                                                    <Radio value={item.title} colorScheme='green'></Radio>
                                                    <Text color={'#222B45'} fontWeight={'400'} fontSize={'14px'} lineHeight={'21.41px'} >{item?.title}</Text>
                                                </Flex>
                                            </Flex>
                                        </GridItem>
                                    ))}
                                </Grid>
                            </RadioGroup>
                            <Button bgColor={'#D11A2A'} color={'#FFFFFF'} fontWeight={'700'} fontSize={'14px'} lineHeight={'21.41px'} borderRadius={'10px'}
                                _hover={{ backgroundColor: "" }} _active={{ backgroundColor: "" }} onClick={handleSubmitPayment}
                            >
                                Pay 
                            </Button>
                        </Flex>
                        <Flex width={['100%', '100%', '100%', '35%']} flexDirection={'column'} bgColor={'#FFFFFF'} border={'1px solid #D7343914'} >
                            <Flex alignItems={'center'} gap={3} bgColor={'#D7343926'} px={['20px', '40px', '40px']} py={'20px'}>
                                <Text color={'#D73439'} fontWeight={'700'} fontSize={'14px'} lineHeight={'16px'} >INSTRUCTIONS</Text>
                            </Flex>
                            <Text px={5} my={5} textAlign={'center'} color={'#D11A2A'} fontWeight={'400'} fontSize={'14px'} lineHeight={'21.41px'}>
                                Please read instructions carefully before making payment to avoid mistakes
                            </Text>
                            <OrderedList px={5} fontSize={'13px'} fontWeight={'400'} lineHeight={'19.88px'} color={'#222B45'}>
                                <ListItem mb={4}>
                                    Please ensure your card is enabled for online payment by your bank before proceeding
                                </ListItem>
                                <ListItem mb={4}>
                                    A transaction may fail due to insufficient funds, wrong credentials, card being blacklisted at issuer bank or network failure.
                                    In the event of a network failure, kindly check with your bank for any debits, before attempting again
                                </ListItem>
                                <ListItem mb={4}>
                                    For Visa Card kindly use Remita Platform.
                                </ListItem>
                            </OrderedList>
                        </Flex>
                    </Flex>
                </Box>
            </Box>
        </Box>
    )
}

export default MemberProfilePaymentModal;